//import {Dialog, Toast} from "vant";
import {Dialog, Toast} from 'vant';


export const GOk = (resolve,resp)=>{
    let res = resp.data;
    /*
    * 1 登录
    * 3 切换用户
    * 4 打开app 首次访问
    * */
    if(res.code==1||res.code==3){
        //
    }

    if(resp.headers['set-x-gold-auth-token']){//是否重新设置X-GOLD-AUTH-TOKEN
        localStorage.setItem("X-GOLD-AUTH-TOKEN",resp.headers['set-x-gold-auth-token']);
    }
    resolve(res);
};

export const GEr = (reject,err,passError,showError)=>{
    console.log(passError)
    if(passError){
        if(showError){
            Toast.fail(err.data.msg);
        }
        reject(err);
    }else{
        //
        //Toast.fail(err.data.msg);
        Dialog.alert({
            confirmButtonText:"Confirm",
            message: err.data.msg,
        }).then(() => {
            // on close
        });
    }
};

export const overlay = (skipOverlay,flag)=>{
    // if(skipOverlay){
    //     store.dispatch("setGeneral", {
    //         key: "isOverlay",
    //         value: flag
    //     })
    // }
};
